import { useContext } from 'react';
import * as fluentIcons from '@fluentui/react-icons';
import { colorPallet } from 'src/styles/theme/colors';
import { TeamsFxContext } from 'src/context/TeamsContext';
import { StatusEnum } from 'src/utils/mappers/checkStatusCode';

export interface RequestIconProps {
  requestStatus: string | number;
  size?: number;
}

export const RequestIcon = ({ requestStatus, size = 16 }: RequestIconProps) => {
  const { themeString } = useContext(TeamsFxContext);

  const iconType = themeString === 'dark' ? 'Filled' : 'Regular';
  const statusIcons = {
    approved: fluentIcons[`CheckmarkCircle${size}${iconType}`],
    rejected: fluentIcons[`ErrorCircle${size}${iconType}`],
    pending: fluentIcons[`MoreCircle${size}${iconType}`],
    cancelled: fluentIcons[`DismissCircle${size}${iconType}`],
    documentsRequired: fluentIcons[`DocumentAdd${size}${iconType}`],
    documentsAccepted: fluentIcons[`DocumentCheckmark${size}${iconType}`],
  };

  switch (requestStatus) {
    case StatusEnum.COMPLETED:
      return <statusIcons.approved color={colorPallet.islamicGreen} />;
    case StatusEnum.REJECTED:
      return <statusIcons.rejected color={colorPallet.oldRose} />;
    case StatusEnum.WAITING_FOR_APPROVAL:
      return <statusIcons.pending color={colorPallet.navyBlue} />;
    case StatusEnum.CANCELLED:
      return <statusIcons.cancelled color={colorPallet.bazaar} />;
    case StatusEnum.DOCUMENTS:
      return <statusIcons.documentsRequired color={colorPallet.blueLagoon} />;
    case StatusEnum.PROCESSED:
      return <statusIcons.documentsAccepted color={colorPallet.green} />;
  }
};
